// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Info Icon Container */
.info-icon-container {
  position: relative;
  display: inline-block;
  z-index: 1000;
}

/* Style the Info Icon */
.info-icon {
  cursor: pointer;
  font-size: 1rem;
  color: #007bff;
}

.info-icon:hover {
  color: #0056b3;
}

/* Tooltip (Pop-up) Styling */
.popup-portal {
  background-color: white;
  border: 1px solid black;
  padding: 10px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  text-align: center;
}
.popup-portal p {
  font-size: 0.9rem;
  margin: 0;
  padding-bottom: 5px;
}
.popup-portal button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 0.9rem;
  border-radius: 5px;
}
.popup-portal button:hover {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/info_icon.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Info Icon Container */\n.info-icon-container {\n  position: relative;\n  display: inline-block;\n  z-index: 1000;\n}\n\n/* Style the Info Icon */\n.info-icon {\n  cursor: pointer;\n  font-size: 1rem;\n  color: #007bff;\n}\n\n.info-icon:hover {\n  color: #0056b3;\n}\n\n/* Tooltip (Pop-up) Styling */\n.popup-portal {\n  background-color: white;\n  border: 1px solid black;\n  padding: 10px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);\n  z-index: 9999;\n  text-align: center;\n}\n.popup-portal p {\n  font-size: 0.9rem;\n  margin: 0;\n  padding-bottom: 5px;\n}\n.popup-portal button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  border-radius: 5px;\n}\n.popup-portal button:hover {\n  background-color: #0056b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
